// extracted by mini-css-extract-plugin
export default {"appLogoStyle":"appLogoStyles_appLogoStyle__frsrk"};